<template>
  <div>
        <div class="row justify-content-center" >
            <div class="col-md-6 col-10">
                <br>                              
                <div class="row justify-content-center" >
                    <div class="col-md-4 mt-2">
                        <h4 style="color:#039cf3;">Filtros:</h4>    
                        <label for="">PDV</label>
                        <select class="form-control mt-3" v-model="f_gerente"  style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;" :disabled="f_coordinador != ''">
                            <option value="" selected >TODOS</option>
                            <option v-for="ge in arrayGerente" :key="ge.id" :value="ge.idpdv">{{ge.idpdv}} - {{ge.idpdv_nombre}}</option>
                        </select>      
                    </div>
                    <div class="col-md-4  mt-5">
                       <br v-if="!isMobile">
                        <label for="">Coordinador</label>
                        <select class="form-control mt-3" v-model="f_coordinador"  style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;" :disabled="f_gerente != ''">
                            <option value="" selected >TODOS</option>
                            <option v-for="co in arrayCoo" :key="co.id" :value="co">{{co.coordinador_nombre}}</option>
                        </select>          
                    </div>
                    <div class="col-md-4 mt-5">  
                        <br v-if="!isMobile">
                        <label for="">Tipo de Venta</label>
                        <select class="form-control mt-3" v-model="f_venta"  style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;">
                            <option value="" selected >TODOS</option>
                            <option value="Pay Joy" >Pay Joy</option>
                            <option value="Renovación" >Renovación</option>
                            <option value="Prepago" >Prepago</option>
                            <option value="Pospago" >Pospago</option>
                        </select>        
                    </div>
                     <div class="col-md-4 mt-5">
                        <label for="">Equipo</label>
                        <select class="form-control mt-3" v-model="f_marca"  style="border-radius: 6px; box-shadow: inset 0 0 10px 0 #CDCDCD;">
                            <option value="" selected >TODOS</option>
                            <option value="Apple" >Apple</option>
                            <option value="Hisense" >Hisense</option>
                            <option value="Huawei" >Huawei</option>
                            <option value="Motorola" >Motorola</option>
                            <option value="Nokia" >Nokia</option>
                            <option value="Samsung" >Samsung</option>
                            <option value="Otra" >Otra</option>
                        </select>         
                    </div>
                     <div class="col-md-4 mt-5">
                        <label for="">Fecha inicio</label>
                        <b-form-input  type="date" v-model="f_inicio" style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-3" />    
                    </div>
                     <div class="col-md-4 mt-5">
                        <label for="">Fecha final</label>
                        <b-form-input  type="date" v-model="f_fin" style="border-radius: 6px;box-shadow: inset 0 0 10px 0 #CDCDCD; " class="mt-3" />           
                    </div>
                    <div class="col-md-2 col-4"></div>
                    <div class="col-md-2 col-4 mt-1">
                        <br><br>
                        <b-button  variant="outline-secondary"  @click="traeGrafico(0)">Filtrar selección <b-spinner small v-if="loader"></b-spinner></b-button>
                    </div>
                    <div class="col-md-2 col-4"></div>
                    <div class="col-md-12"></div>
                    <div class="col-md-4">
                        <hr>
                        <center>
                        <b-button  variant="primary" pill  :style="accion == 2 ? 'margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;' :
                        'margin-top: 25px; width: 100%; background: #039cf3; border-color: #039cf3;  color: #fff;'" 
                        size="sm"  @click="abreModal()">
                                Top Ventas al Día {{fecha}} <b-spinner small v-if="loader2"></b-spinner>
                        </b-button>
                            <!-- <button  type="button" class=" btn btn-success position-relative" @click="traeGrafico()">
                                  Top Ventas al Día {{fecha}} <b-spinner small v-if="loader"></b-spinner>
                            </button> -->
                        </center>
                    </div>
                    <div class="col-md-4">
                        <hr>
                        <center>
                            <b-button  variant="primary" pill style="margin-top: 25px; width: 100%; background: #60CD31; border-color: #60CD31; color: #000;" 
                            size="sm"  @click="reporteExc()">
                                    Reporte Excel <b-spinner small v-if="loader3"></b-spinner>
                            </b-button>
                        </center>
                    </div>
                </div>
            </div>
              
               <div class="col-md-10 col-10 mt-3"> 
                 <div class="row justify-content-center" >
                    <div class="col-md-8 mt-5">
                        <br>
                        <v-card elevation="3" outlined  style="margin-top: -15px;">
                            <v-card-text>
                                 <p style="color:#000;" class="text-center mt-4"><b>Información de  mis PDVs</b></p>
                                  <p style="color:#000; font-size:small;" class="text-center mt-4" v-if=" f_coordinador ||  f_gerente  || f_venta || f_marca || f_inicio || f_fin">
                                    Resultado de tu búsqueda: <br>
                                    <template v-if="f_coordinador">Coordinador: {{f_coordinador.coordinador_nombre}} <br> </template>
                                    <template v-if="f_gerente">PDV: {{f_gerente}} <br> </template>
                                    <template v-if="f_venta">Tipo venta: {{f_venta}} <br> </template>
                                    <template v-if="f_marca">Tipo marca: {{f_marca}} <br> </template>
                                    <template v-if="f_inicio">Fecha inicio: {{f_inicio}} <br> </template>
                                    <template v-if="f_fin">Fecha fin: {{f_fin}} </template>
                                </p>
                                <div id="chart">
                                   <apexchart type="bar" height="980" :options="chartOptionsNew" ></apexchart>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                    <div class="col-md-4 mt-5">
                        <div class="row justify-content-center" >
                            <div class="col-md-12">
                                <div id="chart">
                                    <apexchart type="radialBar" height="500" :options="chartOptions4" ></apexchart>
                                </div>
                            </div>
                            <div :class="filtro != 0 ? 'col-md-6' : 'col-md-12'">
                                <div id="chart">
                                    <apexchart type="radialBar" height="500" :options="chartOptions5" ></apexchart>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="filtro != 0">
                                 <div id="chart">
                                    <apexchart type="radialBar" height="500" :options="chartOptions51" ></apexchart>
                                </div>
                            </div>
                            <div :class="filtro != 0 ? 'col-md-6' : 'col-md-12'">
                                <div id="chart">
                                    <apexchart type="radialBar" height="500" :options="chartOptions6" ></apexchart>
                                </div>
                            </div>
                            <div class="col-md-6" v-if="filtro != 0">
                                <div id="chart">
                                    <apexchart type="radialBar" height="500" :options="chartOptions61" ></apexchart>
                                </div>
                            </div>
                        </div>                            
                    </div>
                 </div>
                </div>

                <div class="col-md-10 col-10 mt-5"> 
                  <br>
                  <b-tabs pills  content-class="mt-3" align="center">
                    <b-tab title="Información ventas y equipos" active>
                        <div class="row justify-content-center" >
                            <div class="col-md-6 mt-5">
                                <br>
                                <div id="bajar"></div>
                                <v-card elevation="3" outlined  style="margin-top: -15px;">
                                    <v-card-text>
                                        <p style="color:#000;" class="text-center mt-4"><b>Información Tipo de Venta</b></p>
                                        <p style="color:#000; font-size:small;" class="text-center mt-4" v-if=" f_coordinador ||  f_gerente   || f_venta || f_marca || f_inicio || f_fin">
                                            Resultado de tu búsqueda: <br>
                                            <template v-if="f_coordinador">Coordinador: {{f_coordinador.coordinador_nombre}} <br> </template>
                                            <template v-if="f_gerente">PDV: {{f_gerente}} <br> </template>
                                            <template v-if="f_venta">Tipo venta: {{f_venta}} <br> </template>
                                            <template v-if="f_marca">Tipo marca: {{f_marca}} <br> </template>
                                            <template v-if="f_inicio">Fecha inicio: {{f_inicio}} <br> </template>
                                            <template v-if="f_fin">Fecha fin: {{f_fin}} </template>
                                        </p>
                                        <div id="chart">
                                            <apexchart type="bar" height="980" :options="chartOptions" :series="series"></apexchart>
                                        </div>
                                    </v-card-text>
                                </v-card>

                            </div>
                            <div class="col-md-6 mt-5">
                                <br>
                                <v-card elevation="3" outlined  style="margin-top: -15px;">
                                    <v-card-text>
                                        <p style="color:#000;"  class="text-center mt-4"><b>Información de Equipos</b></p>
                                        <p style="color:#000; font-size:small;" class="text-center mt-4" v-if=" f_coordinador ||  f_gerente || f_venta || f_marca || f_inicio || f_fin">
                                            Resultado de tu búsqueda: <br>
                                            <template v-if="f_coordinador">Coordinador: {{f_coordinador.coordinador_nombre}} <br> </template>
                                            <template v-if="f_gerente">PDV: {{f_gerente}} <br> </template>
                                            <template v-if="f_venta">Tipo venta: {{f_venta}} <br> </template>
                                            <template v-if="f_marca">Tipo marca: {{f_marca}} <br> </template>
                                            <template v-if="f_inicio">Fecha inicio: {{f_inicio}} <br> </template>
                                            <template v-if="f_fin">Fecha fin: {{f_fin}} </template>
                                        </p>
                                        <div id="chart">
                                        <apexchart type="bar" height="980" :options="chartOptions2" :series="series2"></apexchart>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab title="Tops">
                        <div class="row justify-content-center" >
                            <div class="col-md-6 mt-5">
                                <b-tabs content-class="mt-3" align="center">
                                    <b-tab title="PDVs" active>
                                        <br>
                                        <v-card elevation="3" outlined  style="margin-top: -15px;">
                                            <v-card-text>
                                                <p style="color:#000;" class="text-center mt-4"><b>Top PDVs</b></p>
                                                <div class="table-responsive">
                                                    <table class="table table-hover table-striped mt-3" style="">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">IDPDV</th>
                                                            <th scope="col">Gerente</th>
                                                            <th scope="col">Registros</th>
                                                            <th scope="col" style="width: 15%;">%</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(to, index) in arrayTopGer" :key="to.id" v-show="index < 10">
                                                            <td>{{index + 1}}</td>
                                                            <td>{{to.idpdv}}</td>
                                                            <td>{{to.gerente}}</td>
                                                            <td>{{to.total}}</td>
                                                            <td>
                                                            {{(to.total*100/totalCuota).toFixed(2)}} %
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div> 
                                            </v-card-text>
                                        </v-card>
                                    </b-tab>
                                    <b-tab title="Ejecutivos">
                                        <br>
                                       <v-card elevation="3" outlined  style="margin-top: -15px;">
                                            <v-card-text>
                                                <p style="color:#000;" class="text-center mt-4"><b>Top Ejecutivos</b></p>
                                                <div class="table-responsive">
                                                    <table class="table table-hover table-striped mt-3" style="">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">IDPDV</th>
                                                            <th scope="col">Ejecutivo</th>
                                                            <th scope="col">Registros</th>
                                                            <th scope="col" style="width: 15%;">%</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(toe, index) in arrayTopEje" :key="toe.id" v-show="index < 10">
                                                            <td>{{index + 1}}</td>
                                                            <td>{{toe.idpdv}}</td>
                                                            <td>{{toe.ejecutivo}}</td>
                                                            <td>{{toe.total}}</td>
                                                            <td>
                                                            {{(toe.total*100/totalCuota).toFixed(2)}} %
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div> 
                                            </v-card-text>
                                        </v-card>
                                    </b-tab>
                                    <b-tab title="Coordinadores">
                                        <br>
                                        <v-card elevation="3" outlined  style="margin-top: -15px;">
                                            <v-card-text>
                                                <p style="color:#000;" class="text-center mt-4"><b>Top Coordinadores</b></p>
                                                <div class="table-responsive">
                                                    <table class="table table-hover table-striped mt-3" style="">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">Coordinador</th>
                                                            <th scope="col">Registros</th>
                                                            <th scope="col">%</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(to, index) in arrayTop" :key="to.id" v-show="index < 10">
                                                            <td>{{index + 1}}</td>
                                                            <td>{{to.coordinador}}</td>
                                                            <td>{{to.total}}</td>
                                                            <td>
                                                            {{(to.total*100/totalCuota).toFixed(2)}} %
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div> 
                                            </v-card-text>
                                        </v-card>
                                    </b-tab>
                                    <b-tab title="Subdirectores">
                                        <br>
                                        <v-card elevation="3" outlined  style="margin-top: -15px;">
                                            <v-card-text>
                                                <p style="color:#000;" class="text-center mt-4"><b>Top Subdirectores</b></p>
                                                <div class="table-responsive">
                                                    <table class="table table-hover table-striped mt-3" style="">
                                                        <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">Subdirector</th>
                                                            <th scope="col">Registros</th>
                                                            <th scope="col">%</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="(to, index) in arrayTopSub" :key="to.id" v-show="index < 10">
                                                            <td>{{index + 1}}</td>
                                                            <td>{{to.subdirector}}</td>
                                                            <td>{{to.total}}</td>
                                                            <td>
                                                            {{(to.total*100/totalCuota).toFixed(2)}} %
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div> 
                                            </v-card-text>
                                        </v-card>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                    </b-tab>
                  </b-tabs>
                  <br><br>
                </div>
             
        </div>
        

         <b-modal id="graficoDia" title="Top Ventas al Día" size="xl" hide-footer header-close-content="Cerrar"   header-text-variant="light">
            <v-card elevation="13" outlined  style="box-shadow: 0px 0px 10px 0px #000 ;">
                <v-card-text>
                    <br>
                    <b-tabs content-class="mt-3" align="center">
                            <b-tab title="Tiendas" active>
                                <br>
                                <center><b style="color:#000;">Top Avance Ventas {{fecha}}</b></center>
                                <div class="row  justify-content-center" >
                                 <div class="col-md-10 mt-2" >
                                    <h6 class="text-center" style="color:#000;">Top Tiendas</h6>
                                    <div id="chart">
                                        <apexchart type="bar" height="680" :options="chart3" ></apexchart>
                                    </div>
                                  </div>
                                </div>
                            </b-tab>
                            <b-tab title="Ejecutivos">
                                <br>
                                <center><b style="color:#000;">Top Avance Ventas {{fecha}}</b></center>
                                <div class="row  justify-content-center" >
                                 <div class="col-md-10 mt-2" >
                                    <h6 class="text-center" style="color:#000;">Top Ejecutivos</h6>
                                    <div id="chart">
                                        <apexchart type="bar" height="680" :options="chart1" ></apexchart>
                                    </div>
                                  </div>
                                </div>
                            </b-tab>
                            <b-tab title="Gerentes" >
                                <br>
                                <center><b style="color:#000;">Top Avance Ventas {{fecha}}</b></center>
                               <div class="row  justify-content-center" >
                                 <div class="col-md-10 mt-2" >
                                    <h6 class="text-center" style="color:#000;">Top Gerentes</h6>
                                    <div id="chart">
                                        <apexchart type="bar" height="680" :options="chart5" ></apexchart>
                                    </div>
                                  </div>
                                </div>
                            </b-tab>
                            <b-tab title="Coordinadores" >
                                <br>
                                <center><b style="color:#000;">Top Avance Ventas {{fecha}}</b></center>
                                <div class="row  justify-content-center" >
                                 <div class="col-md-10 mt-2" >
                                  <h6 class="text-center" style="color:#000;">Top Coordinadores</h6>
                                  <div id="chart">
                                    <apexchart type="bar" height="680" :options="chart4" ></apexchart>
                                  </div>
                                  </div>
                                </div>
                            </b-tab>
                            <b-tab title="Equipos" >
                                <br>
                                <center><b style="color:#000;">Top Avance Ventas {{fecha}}</b></center>
                                <div class="row  justify-content-center" >
                                 <div class="col-md-10 mt-2" >
                                   <h6 class="text-center" style="color:#000;">Top Equipos</h6>
                                    <div id="chart">
                                        <apexchart type="bar" height="680" :options="chart2" ></apexchart>
                                    </div>
                                  </div>
                                </div>
                            </b-tab>
                    </b-tabs>
                </v-card-text>
            </v-card>                         
         </b-modal>

  </div>
</template>

<script>
import apexchart from 'vue-apexcharts'
import moment from 'moment';
export default {
    name:"Registro",
    components:{ apexchart  },
    data() {
     return {
        isMobile: this.$mobile(),
        f_coordinador:"",
        f_gerente:"",
        f_ejecutivo:"",
        f_venta:"",
        f_marca:"",
        f_inicio:"",
        f_fin:"",
        accion:1,
        chartOptions:{},
        chartOptions2:{},
        chartOptions3:{},
        chartOptions4:{},
        chartOptions5:{},
        chartOptions51:{},
        chartOptions6:{},
        chartOptions61:{},
        chartOptionsNew:{},
        chart1:{},
        chart2:{},
        chart3:{},
        chart4:{},
        chart5:{},
        apple:0,
        hisense:0,
        huawei:0,
        motorola:0,
        nokia:0,
        samsung:0,
        otra:0,
        fecha:"",
        arrayDetalle:[],
        arrayDetalle2:[],
        arrayDetalle3:[],
        arrayDetalle4:[],
        loader:false,
        loader2:false,
        loader3:false,
        arrayVenta: [],
        valida2:0,
        marca:0,
        arrayEjecutivo:[],
        arrayGerente:[],
        arrayCoo:[],
        // 
        totalCuota:0,
        totalReal:0,
        prepago:0,
        pospago:0,
        renovacion:0,
        payjoy:0,
        avance:0,
        arrayTopEje:[],
        arrayTop:[],
        arrayTopGer:[],
        arrayTopSub:[],
        filtro:0,
        cuotaPrepago:0,
        cuotaPospago:0,
        cuotaReno:0,
     }
    },
    filters: {
        fechaA:function(value) {
            if (value) {
                moment.locale('es')
                return moment(String(value)).format('YYYY-MM-DD h:mm:ss a')
            }
        }
    },
    computed: {
        user() {
           return this.$store.getters.getInfoUser;
        },
        series(){
            return  [{
                    data: [this.nuevo, this.payjoy, this.prepago, this.pospago, this.renovacion]
                }]
        },
        series11(){
            return  [{
                    data: [this.nuevoD, this.payjoyD, this.prepagoD, this.pospagoD, this.renovacionD]
                }]
        },
        series2(){
            return  [{
                    data: [this.apple, this.hisense, this.huawei, this.motorola, this.nokia, this.samsung, this.otra]
                }]
        },
        series22(){
            return  [{
                    data: [this.appleD, this.hisenseD, this.huaweiD, this.motorolaD, this.nokiaD, this.samsungD, this.otraD]
                }]
        },
        series3(){
            return  [{
                    data: [456, 686 , 756]
                }]
        },
        series4(){
            return  [{
                    data: [43, 54  , 65]
                }]
        }
    },
    methods:{
        grafico1(){
          this.chartOptions =   {
                    series: [{
                     data: this.arrayVenta
                    }],
                    chart: {
                    id: 'barYear',
                    height: 360,
                    width: '100%',
                    type: 'bar',
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    bar: {
                        distributed: true,
                        horizontal: false,
                        barHeight: '65%',
                        dataLabels: {
                        position: 'top'
                        }
                    }
                    },
                    dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        (val / 1).toFixed(2).replace(",", ",")
                          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                           offsetY: -20,
                    style: {
                        fontSize: '13px',
                        colors: ["#000"]
                    }
                    },
                    
                    // colors: colors,
                    
                    states: {
                    normal: {
                        filter: {
                        type: 'desaturate'
                        }
                    },
                    active: {
                        allowMultipleDataPointsSelection: true,
                        filter: {
                        type: 'darken',
                        value: 1
                        }
                    }
                    },
                    tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                        formatter: function (val, opts) {
                            return opts.w.globals.labels[opts.dataPointIndex]
                        }
                        }
                    }
                    },
                    yaxis: {
                        show:false,
                        labels: {
                            show: false
                        }
                    },
                      xaxis: {
                        show:false,
                      }
            };
        
        },
        grafico2(){
            if (this.valida2 == 0) {
               this.chartOptions2 = {
                    series: [{
                        data: [this.apple, this.hisense, this.huawei, this.motorola, this.nokia, this.samsung, this.otra]
                    }],
                    chart: {
                    type: 'bar',
                    height: 362,
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            horizontal: false,
                             dataLabels: {
                            position: 'top'
                            }
                        }
                    },
                    dataLabels: {
                    enabled: true,
                       formatter: function (val) {
                        (val / 1).toFixed(2).replace(",", ",")
                          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                           offsetY: -20,
                    style: {
                        fontSize: '13px',
                        colors: ["#000"]
                    }
                    },
                    tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                        formatter: function (val, opts) {
                            return opts.w.globals.labels[opts.dataPointIndex]
                        }
                        }
                    }
                    },
                    xaxis: {
                      categories: ['Apple', 'Hisense', 'Huawei','Motorola','Nokia','Samsung','Otra' ],
                    },
                      yaxis: {
                        show:false,
                    },
                    };
            }else{
                this.chartOptions2 = {
                    series: [{
                        data: [this.marca]
                    }],
                    chart: {
                    type: 'bar',
                    height: 362,
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,                        
                         dataLabels: {
                        position: 'top'
                        }
                    }
                    },
                    dataLabels: {
                    enabled: true,
                           formatter: function (val) {
                        (val / 1).toFixed(2).replace(",", ",")
                          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                           offsetY: -20,
                        style: {
                            fontSize: '13px',
                            colors: ["#000"]
                        }
                    },
                    tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                        formatter: function (val, opts) {
                            return opts.w.globals.labels[opts.dataPointIndex]
                        }
                        }
                    }
                    },
                    xaxis: {
                    categories: [this.f_marca ],
                    },
                       yaxis: {
                        show:false,
                    },
                    };
            }
        
        },
        grafico(){
               
         this.chart1 = {
            series: [{
            data: this.arrayDetalle
            }],
            chart: {
                id: 'barYear',
                // height: 240,
                fontFamily: 'sans-serif',
                width: '100%',
                type: 'bar',
                     toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
            },
            plotOptions: {
            bar: {
                distributed: false,
                horizontal: true,
                // barHeight: '60%',
                dataLabels: {
                position: 'bottom'
                }
            }
            },
            dataLabels: {
            enabled: true,
            textAnchor: 'start',
                style: {
                    colors: ['#000'],
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold',
                },
            formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ' -- ' + val
            },
            offsetX: 0,
            dropShadow: {
                enabled: false
            }
            },
            
            colors: ['#039CF3'],
            
            states: {
            normal: {
                filter: {
                type: 'desaturate'
                }
            },
            active: {
                allowMultipleDataPointsSelection: true,
                filter: {
                type: 'darken',
                value: 1
                }
            }
            },
            tooltip: {
            x: {
                show: false
            },
            y: {
                title: {
                formatter: function (val, opts) {
                    return opts.w.globals.labels[opts.dataPointIndex]
                }
                }
            }
            },
            yaxis: {
            labels: {
                show: false
            }
            }
         };

        },
        grafico22(){
            this.chart2 = {
                series: [{
                data: this.arrayDetalle2
                }],
                chart: {
                id: 'barYear',
                // height: 240,
                fontFamily: 'sans-serif',
                width: '100%',
                type: 'bar',
                     toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                },
                plotOptions: {
                bar: {
                    distributed: false,
                    horizontal: true,
                    // barHeight: '72%',
                    dataLabels: {
                    position: 'bottom'
                    }
                }
                },
                dataLabels: {
                enabled: true,
                textAnchor: 'start',
                style: {
                    colors: ['#000'],
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold',
                },
                formatter: function (val, opt) {
                    return opt.w.globals.labels[opt.dataPointIndex] + ' -- ' + val
                },
                offsetX: 0,
                dropShadow: {
                    enabled: false
                }
                },
                
                colors: ['#1DC817'],
                
                states: {
                normal: {
                    filter: {
                    type: 'desaturate'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: {
                    type: 'darken',
                    value: 1
                    }
                }
                },
                tooltip: {
                x: {
                    show: false
                },
                y: {
                    title: {
                    formatter: function (val, opts) {
                        return opts.w.globals.labels[opts.dataPointIndex]
                    }
                    }
                }
                },
                yaxis: {
                labels: {
                    show: false
                }
                }
         };

        },
        grafico23(){
            this.chart3 = {
                series: [{
                data: this.arrayDetalle3
                }],
                chart: {
                id: 'barYear',
                // height: 240,
                fontFamily: 'sans-serif',
                width: '100%',
                type: 'bar',
                     toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                },
                plotOptions: {
                bar: {
                    distributed: false,
                    horizontal: true,
                    // barHeight: '32%',
                    dataLabels: {
                    position: 'bottom'
                    }
                }
                },
                dataLabels: {
                enabled: true,
                textAnchor: 'start',
                    style: {
                    colors: ['#000'],
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold',
                },
                formatter: function (val, opt) {
                    return opt.w.globals.labels[opt.dataPointIndex] + ' -- ' + val
                },
                offsetX: 0,
                dropShadow: {
                    enabled: false
                }
                },
                
                colors: ['#1DC817'],
                
                states: {
                normal: {
                    filter: {
                    type: 'desaturate'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: {
                    type: 'darken',
                    value: 1
                    }
                }
                },
                tooltip: {
                x: {
                    show: false
                },
                y: {
                    title: {
                    formatter: function (val, opts) {
                        return opts.w.globals.labels[opts.dataPointIndex]
                    }
                    }
                }
                },
                yaxis: {
                labels: {
                    show: false
                }
                }
         };

        },
        grafico24(){
            this.chart4 = {
                series: [{
                data: this.arrayDetalle4
                }],
                chart: {
                id: 'barYear',
                // height: 240,
                fontFamily: 'sans-serif',
                width: '100%',
                type: 'bar',
                     toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                },
                plotOptions: {
                bar: {
                    distributed: false,
                    horizontal: true,
                    // barHeight: '32%',
                    dataLabels: {
                    position: 'bottom'
                    }
                }
                },
                dataLabels: {
                enabled: true,
                textAnchor: 'start',
                  style: {
                    colors: ['#000'],
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold',
                },
                formatter: function (val, opt) {
                    return opt.w.globals.labels[opt.dataPointIndex] + ' -- ' + val
                },
                offsetX: 0,
                dropShadow: {
                    enabled: false
                }
                },
                
                colors: ['#039CF3'],
                
                states: {
                normal: {
                    filter: {
                    type: 'desaturate'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: {
                    type: 'darken',
                    value: 1
                    }
                }
                },
                tooltip: {
                x: {
                    show: false
                },
                y: {
                    title: {
                    formatter: function (val, opts) {
                        return opts.w.globals.labels[opts.dataPointIndex]
                    }
                    }
                }
                },
                yaxis: {
                labels: {
                    show: false
                }
                }
         };

        },
        grafico25(){
            this.chart5 = {
                series: [{
                data: this.arrayDetalle5
                }],
                chart: {
                id: 'barYear',
                fontFamily: 'sans-serif',
                width: '100%',
                type: 'bar',
                     toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                },
                plotOptions: {
                bar: {
                    distributed: false,
                    horizontal: true,
                    // barHeight: '32%',
                    dataLabels: {
                    position: 'bottom'
                    }
                }
                },
                dataLabels: {
                enabled: true,
                textAnchor: 'start',
                    style: {
                    colors: ['#000'],
                    fontFamily: 'sans-serif',
                    fontWeight: 'bold',
                },
                formatter: function (val, opt) {
                    return opt.w.globals.labels[opt.dataPointIndex] + ' -- ' + val
                },
                offsetX: 0,
                dropShadow: {
                    enabled: false
                }
                },
                
                colors: ['#1DC817'],
                
                states: {
                normal: {
                    filter: {
                    type: 'desaturate'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: true,
                    filter: {
                    type: 'darken',
                    value: 1
                    }
                }
                },
                tooltip: {
                x: {
                    show: false
                },
                y: {
                    title: {
                    formatter: function (val, opts) {
                        return opts.w.globals.labels[opts.dataPointIndex]
                    }
                    }
                }
                },
                yaxis: {
                labels: {
                    show: false
                }
                }
         };

        },
        grafico3(){
         if (!this.f_venta)
         {
          this.chartOptions3 = {
                series: [
                {
                    name: 'Actual',
                    data: [
                        {
                            x: 'Prepago',
                            y: this.prepago,
                            goals: [
                            {
                                name: 'Cuota Real',
                                value: 40,
                                strokeHeight: 5,
                                strokeColor: '#775DD0'
                            }
                            ]
                        },
                        {
                            x: 'Pospago',
                            y: this.pospago,
                            goals: [
                            {
                                name: 'Cuota Real',
                                value: 104,
                                strokeHeight: 5,
                                strokeColor: '#775DD0'
                            }
                            ]
                        },
                        {
                            x: 'Renovaciones',
                            y: this.renovacion,
                            goals: [
                            {
                                name: 'Cuota Real',
                                value: 359,
                                strokeHeight: 5,
                                strokeColor: '#775DD0'
                            }
                            ]
                        },
                        {
                            x: 'PayJoy',
                            y: this.payjoy
                        }
                    ]
                }
                ],
                chart: {
                height: 370,
                fontFamily: 'sans-serif',
                type: 'bar',
                     toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                },
                plotOptions: {
                bar: {
                    columnWidth: '60%'
                }
                },
                colors: ['#00E396'],
                dataLabels: {
                enabled: true
                },
                legend: {
                show: true,
                showForSingleSeries: true,
                customLegendItems: ['Cuota', 'Cuota Real'],
                markers: {
                    fillColors: ['#00E396', '#775DD0']
                }
                }
            };
         }else if(this.f_venta == 'Pay Joy'){
            this.chartOptions3 = {
                    series: [
                    {
                        name: 'Actual',
                        data: [
                            {
                                x: 'PayJoy',
                                y: this.payjoy
                            }
                        ]
                    }
                    ],
                    chart: {
                    height: 370,
                    fontFamily: 'sans-serif',
                    type: 'bar',
                        toolbar: {
                            show: false,
                        tools:{
                            download: false 
                            },
                        }
                    },
                    plotOptions: {
                    bar: {
                        columnWidth: '60%'
                    }
                    },
                    colors: ['#00E396'],
                    dataLabels: {
                    enabled: true
                    },
                    legend: {
                    show: true,
                    showForSingleSeries: true,
                    customLegendItems: ['Cuota', 'Cuota Real'],
                    markers: {
                        fillColors: ['#00E396', '#775DD0']
                    }
                }
            };
         }else if(this.f_venta == 'Renovación'){
            this.chartOptions3 = {
                    series: [
                    {
                        name: 'Actual',
                        data: [
                            {
                                x: 'Renovaciones',
                                y: this.renovacion,
                                goals: [
                                {
                                    name: 'Cuota Real',
                                    value: 359,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                                ]
                            }
                        ]
                    }
                    ],
                    chart: {
                    height: 370,
                    fontFamily: 'sans-serif',
                    type: 'bar',
                        toolbar: {
                            show: false,
                        tools:{
                            download: false 
                            },
                        }
                    },
                    plotOptions: {
                    bar: {
                        columnWidth: '60%'
                    }
                    },
                    colors: ['#00E396'],
                    dataLabels: {
                    enabled: true
                    },
                    legend: {
                    show: true,
                    showForSingleSeries: true,
                    customLegendItems: ['Cuota', 'Cuota Real'],
                    markers: {
                        fillColors: ['#00E396', '#775DD0']
                    }
                }
            };
         }else if(this.f_venta == 'Prepago'){
            this.chartOptions3 = {
                    series: [
                    {
                        name: 'Actual',
                        data: [
                            {
                                x: 'Prepago',
                                y: this.prepago,
                                goals: [
                                {
                                    name: 'Cuota Real',
                                    value: 40,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                                ]
                            }
                        ]
                    }
                    ],
                    chart: {
                    height: 370,
                    fontFamily: 'sans-serif',
                    type: 'bar',
                        toolbar: {
                            show: false,
                        tools:{
                            download: false 
                            },
                        }
                    },
                    plotOptions: {
                    bar: {
                        columnWidth: '60%'
                    }
                    },
                    colors: ['#00E396'],
                    dataLabels: {
                    enabled: true
                    },
                    legend: {
                    show: true,
                    showForSingleSeries: true,
                    customLegendItems: ['Cuota', 'Cuota Real'],
                    markers: {
                        fillColors: ['#00E396', '#775DD0']
                    }
                }
            };
         }else if(this.f_venta == 'Pospago'){
            this.chartOptions3 = {
                    series: [
                    {
                        name: 'Actual',
                        data: [
                            {
                                x: 'Pospago',
                                y: this.pospago,
                                goals: [
                                {
                                    name: 'Cuota Real',
                                    value: 104,
                                    strokeHeight: 5,
                                    strokeColor: '#775DD0'
                                }
                                ]
                            }
                        ]
                    }
                    ],
                    chart: {
                    height: 370,
                    fontFamily: 'sans-serif',
                    type: 'bar',
                        toolbar: {
                            show: false,
                        tools:{
                            download: false 
                            },
                        }
                    },
                    plotOptions: {
                    bar: {
                        columnWidth: '60%'
                    }
                    },
                    colors: ['#00E396'],
                    dataLabels: {
                    enabled: true
                    },
                    legend: {
                    show: true,
                    showForSingleSeries: true,
                    customLegendItems: ['Cuota', 'Cuota Real'],
                    markers: {
                        fillColors: ['#00E396', '#775DD0']
                    }
                }
            };
         }
        },
        grafico4(){
            this.chartOptions4 = {
                    series: [this.totalCuota],
                    chart: {
                    height: 210,
                    type: 'radialBar',
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#fff',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                        },
                        track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                        },
                    
                        dataLabels: {
                        show: true,
                        name: {
                            offsetY: 25,
                            show: true,
                            color: '#888',
                            fontSize: '10px'
                        },
                        value: {
                            formatter: function (val) {
                            (val / 1).toFixed(2).replace(",", ",")
                            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            },
                            color: '#111',
                            fontSize: '20px',
                            show: true,
                             offsetY: -15,
                        }
                        }
                    }
                    },
                    fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#ABE5A1'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                    },
                    stroke: {
                    lineCap: 'round'
                    },
                    labels: ['Cuota PDVs'],
            };

            this.chartOptions5 = {
                    series: [this.totalReal],
                    chart: {
                    height: 210,
                    type: 'radialBar',
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#fff',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                        },
                        track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                        },
                    
                        dataLabels: {
                        show: true,
                        name: {
                            offsetY: 25,
                            show: true,
                            color: '#887',
                            fontSize: '10px'
                        },
                        value: {
                             formatter: function (val) {
                            (val / 1).toFixed(2).replace(",", ",")
                            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            },
                            color: '#111',
                            fontSize: '20px',
                            show: true,
                            offsetY: -15,
                        }
                        }
                    }
                    },
                    fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#F7C107'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                    },
                    stroke: {
                    lineCap: 'round'
                    },
                    labels: ['Avance PDVs'],
            };

            this.chartOptions51 = {
                    series: [this.prepagoPDV + this.pospagoPDV + this.renovacionPDV + this.payjoyPDV],
                    chart: {
                    height: 210,
                    type: 'radialBar',
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#fff',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                        },
                        track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                        },
                    
                        dataLabels: {
                        show: true,
                        name: {
                            offsetY: 25,
                            show: true,
                            color: '#887',
                            fontSize: '10px'
                        },
                        value: {
                             formatter: function (val) {
                            (val / 1).toFixed(2).replace(",", ",")
                            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            },
                            color: '#111',
                            fontSize: '20px',
                            show: true,
                            offsetY: -15,
                        }
                        }
                    }
                    },
                    fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#F7C107'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                    },
                    stroke: {
                    lineCap: 'round'
                    },
                    labels: ['Avance Búsqueda'],
            };

            this.chartOptions6 = {
                    series: [this.avance],
                    chart: {
                    height: 210,
                    type: 'radialBar',
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#fff',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                        },
                        track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                        },
                    
                        dataLabels: {
                        show: true,
                        name: {
                            offsetY:  25,
                            show: true,
                            color: '#887',
                            fontSize: '10px'
                        },
                        value: {
                            formatter: function(val) {
                            return parseFloat(val.toFixed(2)) + '%';
                            },
                            color: '#111',
                            fontSize: '20px',
                            show: true,
                            offsetY: -15,
                        }
                        }
                    }
                    },
                    fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#ABE5A1'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                    },
                    stroke: {
                    lineCap: 'round'
                    },
                    labels: ['% Avance'],
            };

            this.chartOptions61 = {
                    series: [(this.prepagoPDV + this.pospagoPDV + this.renovacionPDV + this.payjoyPDV) * 100 / this.totalCuota],
                    chart: {
                    height: 210,
                    type: 'radialBar',
                    fontFamily: 'sans-serif',
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    radialBar: {
                        startAngle: -135,
                        endAngle: 225,
                        hollow: {
                        margin: 0,
                        size: '70%',
                        background: '#fff',
                        image: undefined,
                        imageOffsetX: 0,
                        imageOffsetY: 0,
                        position: 'front',
                        dropShadow: {
                            enabled: true,
                            top: 3,
                            left: 0,
                            blur: 4,
                            opacity: 0.24
                        }
                        },
                        track: {
                        background: '#fff',
                        strokeWidth: '67%',
                        margin: 0, // margin is in pixels
                        dropShadow: {
                            enabled: true,
                            top: -3,
                            left: 0,
                            blur: 4,
                            opacity: 0.35
                        }
                        },
                    
                        dataLabels: {
                        show: true,
                        name: {
                            offsetY:  25,
                            show: true,
                            color: '#887',
                            fontSize: '10px'
                        },
                        value: {
                            formatter: function(val) {
                            return parseFloat(val.toFixed(2)) + '%';
                            },
                            color: '#111',
                            fontSize: '20px',
                            show: true,
                            offsetY: -15,
                        }
                        }
                    }
                    },
                    fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#ABE5A1'],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100]
                    }
                    },
                    stroke: {
                    lineCap: 'round'
                    },
                    labels: ['Avance Búsqueda'],
            };
        },
        graficoNew(){
         if (this.filtro == 0) {
               this.chartOptionsNew  = {
                    series: [{
                        name: 'Cuota PDVs',
                        data: [this.cuotaPrepago, this.cuotaPospago, this.cuotaReno, 0]
                    }, {
                        name: 'PDVs',
                        data: [this.prepago, this.pospago, this.renovacion, this.payjoy  ]
                    }
                    ],
                    chart: {
                    type: 'bar',
                    height: 470,
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                         dataLabels: {
                        position: 'top'
                        }
                    },
                    },
                       dataLabels: {
                    enabled: true,
                           formatter: function (val) {
                        (val / 1).toFixed(2).replace(",", ",")
                          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                                   offsetY: -20,
                    style: {
                        fontSize: '13px',
                        colors: ["#000"]
                    }
                    },
                    stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                    },
                    xaxis: {
                    categories: ['Prepago', 'Pospago', 'Renovaciones', 'PayJoy'],
                    },
                    yaxis: {
                        show:false,
                    title: {
                        text: ''
                    }
                    },
                    fill: {
                    opacity: 1
                    },
                    tooltip: {
                    y: {
                        formatter: function (val) {
                        return "" + val + ""
                        }
                    }
                    }
                };
         }else if(this.filtro == 1){
           this.chartOptionsNew  = {
                    series: [{
                        name: 'Cuota PDVs',
                        data: [this.cuotaPrepago, this.cuotaPospago, this.cuotaReno, 0]
                    }, {
                        name: 'PDVs',
                        data: [this.prepago, this.pospago, this.renovacion, this.payjoy  ]
                    }, {
                        name: 'Avance Búsqueda',
                        data: [this.prepagoPDV, this.pospagoPDV, this.renovacionPDV, this.payjoyPDV  ]
                    }
                    ],
                    chart: {
                    type: 'bar',
                    height: 470,
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                         dataLabels: {
                        position: 'top'
                        }
                    },
                    },
                    dataLabels: {
                    enabled: true,
                           formatter: function (val) {
                        (val / 1).toFixed(2).replace(",", ",")
                          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                                   offsetY: -20,
                    style: {
                        fontSize: '13px',
                        colors: ["#000"]
                    }
                    },
                    stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                    },
                    xaxis: {
                    categories: ['Prepago', 'Pospago', 'Renovaciones', 'PayJoy'],
                    },
                    yaxis: {
                        show:false,
                    title: {
                        text: ''
                    }
                    },
                    fill: {
                    opacity: 1
                    },
                    tooltip: {
                    y: {
                        formatter: function (val) {
                        return "" + val + ""
                        }
                    }
                    }
                    };
         }else if(this.filtro == 2){
           this.chartOptionsNew  = {
                    series: [{
                        name: 'Cuota PDVs',
                        data: [this.cuotaPrepago, this.cuotaPospago, this.cuotaReno, 0]
                    }, {
                        name: 'PDVs',
                        data: [this.prepago, this.pospago, this.renovacion, this.payjoy  ]
                    }, {
                        name: 'Avance Búsqueda',
                        data: [this.prepagoPDV, this.pospagoPDV, this.renovacionPDV, this.payjoyPDV  ]
                    }
                    ],
                    chart: {
                    type: 'bar',
                    height: 470,
                    toolbar: {
                        show: false,
                     tools:{
                          download: false 
                        },
                     }
                    },
                    plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                         dataLabels: {
                        position: 'top'
                        }
                    },
                    },
                       dataLabels: {
                    enabled: true,
                           formatter: function (val) {
                        (val / 1).toFixed(2).replace(",", ",")
                          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },
                                   offsetY: -20,
                    style: {
                        fontSize: '13px',
                        colors: ["#000"]
                    }
                    },
                    stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                    },
                    xaxis: {
                    categories: ['Prepago', 'Pospago', 'Renovaciones', 'PayJoy'],
                    },
                    yaxis: {
                        show:false,
                    title: {
                        text: ''
                    }
                    },
                    fill: {
                    opacity: 1
                    },
                    tooltip: {
                    y: {
                        formatter: function (val) {
                        return "" + val + ""
                        }
                    }
                    }
                    };
         }
        }, 
        traeGrafico(id){

            var coor = "";
            if (this.f_coordinador)
            {
                coor = this.f_coordinador.coordinador_nombre;
            }

            if (this.accion == 1)
            {
               this.loader = true; 
               this.$scrollTo("#bajar");
            } 
            var url= 'cantado/graficoTrad?sub=' +  this.user.mrt  +  '&venta=' +  this.f_venta + '&marca=' +  this.f_marca 
            + '&inicio=' +  this.f_inicio + '&fin=' +  this.f_fin  + '&ejecutivos=' +  this.f_ejecutivo  + '&gerente=' +  this.f_gerente + '&coordinador=' +  coor;
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.accion = 1;
                    
                    this.arrayVenta = data.data.grafico1;

                    this.apple = data.data.apple;
                    this.hisense = data.data.hisense;
                    this.huawei = data.data.huawei;
                    this.motorola = data.data.motorola;
                    this.nokia = data.data.nokia;
                    this.samsung = data.data.samsung;
                    this.otra = data.data.otra;
                    this.marca = data.data.marca;

                    this.valida2 = data.data.grafico2;
                    
                    this.arrayDetalle = data.data.detalles;
                    this.arrayDetalle2 = data.data.detalles2;
                    this.arrayDetalle3 = data.data.detalles3;
                    this.arrayDetalle4 = data.data.detalles4;
                    this.arrayDetalle5 = data.data.detalles5;
                    
                    this.totalCuota = data.data.totalCuota;
                    this.totalReal = data.data.totalReal;

                    this.prepago = data.data.prepago;
                    this.pospago = data.data.pospago;
                    this.renovacion = data.data.renovacion;
                    this.payjoy = data.data.payjoy;

                    this.prepagoPDV = data.data.prepagoPDV;
                    this.pospagoPDV = data.data.pospagoPDV;
                    this.renovacionPDV = data.data.renovacionPDV;
                    this.payjoyPDV = data.data.payjoyPDV;

                        
                    this.cuotaPrepago = data.data.cuotaPrepago;
                    this.cuotaPospago = data.data.cuotaPospago;
                    this.cuotaReno = data.data.cuotaReno;

                    this.arrayTop = data.data.topCoo;
                    this.arrayTopEje = data.data.topEje;
                    this.arrayTopGer = data.data.topGer;
                    this.arrayTopSub = data.data.topSub;

                    this.avance = data.data.avance;

                    this.filtro = data.data.filtro;

                    this.loader = false;
                    this.loader2 = false;

                    setTimeout(() => {
                        this.grafico1();
                        this.grafico2();
                        this.grafico();
                        this.grafico22();
                        this.grafico23();
                        this.grafico24();
                        this.grafico25();
                        this.grafico3();
                        this.grafico4();
                        this.graficoNew();
                        this.fecha = moment().format('YYYY-MM-DD h:mm:ss a');
                        
                     }, 500); 

                    if (id == 1)
                    {
                            this.$bvModal.show('graficoDia') 
                    } 
                }
            );
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(",", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        abreModal(){
            this.accion = 2;
            this.loader2 = true;
            this.traeGrafico(1);
        },
        traeCoo(){
            var url= 'cantado/coordinadorTrade';
                this.$api.get(url).then(
                    ({data}) => {
                        console.log(data);
                        this.arrayCoo = data.data.coordinadores;    
                    }
              ); 
        },
        traeGerente(){
          var url= 'cantado/pdvSubsTrade';
            this.$api.get(url).then(
                ({data}) => {
                    console.log(data);
                    this.arrayGerente = data.data.pdvs;    
                }
            ); 
        },
        reporteExc(){
            this.loader3 = true;
            this.$fileDownload(
                        this.$api.baseUri + 'cantado/reporte?idpdv='+ this.user.id_pdv  +  '&perfil=' +  this.user.perfiles[0].perfil.id +  '&mrt=' +  this.user.mrt,
                        "reporte-cantado.xlsx",
                ).then(
                    () => {
                        this.loader3 = false;
                    }
                )
        }
    },
    mounted(){
        this.traeGrafico(1);
        this.traeCoo();
        this.traeGerente();
    }

}
</script>

<style>
#graficoDia .modal-content{
    background: #039cf3;
}
</style>